// PostHog analytics initialization
export const initPostHog = () => {
  // Wait for PostHog script to load from HTML
  const checkPostHog = () => {
    const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
    const posthogHost = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

    if (!posthogKey) {
      return; // No API key configured, skip initialization
    }

    if (window.posthog && typeof window.posthog.init === 'function') {
      window.posthog.init(posthogKey, {
        api_host: posthogHost,
        person_profiles: "identified_only",
      });
    } else {
      // Retry after a short delay if PostHog script hasn't loaded yet
      setTimeout(checkPostHog, 100);
    }
  };

  // Start checking for PostHog availability
  checkPostHog();
};

